export type SET_ASSISTANT_PAGES_LOADING = "SET_ASSISTANT_PAGES_LOADING";
export type SET_ASSISTANT_PAGES = "SET_ASSISTANT_PAGES";

export type SET_ASSISTANT_PAGE = "SET_ASSISTANT_PAGE";
export type SET_ASSISTANT_OPEN = "SET_ASSISTANT_OPEN";

export type SET_CHAT_KIT_AVAILABILITY = "SET_CHAT_KIT_AVAILABILITY";

export enum assistantPageCodeEnum {
  VIEW_PROPERTY = "VIEW_PROPERTY",
  MY_DEALS = "MY_DEALS",
  PROPERTIES_MAP = "PROPERTIES_MAP",
}
